<template>
    <span>
        <button
            type="button"
            :class="deliveryPhase.completed ? completedClasses : uncompletedClasses"
            :disabled="! canEditDeliveryPhase"
            @click="hasSlotContent() ? showModal() : (deliveryPhase.completed ? saveUncomplete() : showModal())"
        >
            <template v-if="hasSlotContent()">
                <slot />
            </template>
            <template v-else>
                {{ deliveryPhase.completed ? 'Ångra' : 'Klarmarkera' }}
            </template>
        </button>

        <adaptive-form-modal
            :name="modalName"
            title="Hantera klarmarkering"
            primary-button-text="Godkänn klarmarkering"
            method="post"
            :action="route('api.delivery-projects.addresses.delivery-phases.store', deliveryPhase.address_id)"
            :callback="handleUpdateResponse"
        >
            <input
                type="hidden"
                name="type"
                :value="deliveryPhase.type"
            >
            <input
                type="hidden"
                name="completed"
                value="1"
            >
            <div class="mb-xl">
                <text-input
                    label="Datum"
                    type="date"
                    name="completed_at"
                    :value="deliveryPhase.completed_at"
                    :required="true"
                />
            </div>
            <text-input
                v-if="canEnterHours"
                label="Antal arbetade timmar"
                type="number"
                name="hours_worked"
                :value="deliveryPhase.hours_worked"
                :required="true"
            />
            <div v-if="canEnterMeters" class="mt-lg">
                <text-input
                    label="Antal grävda meter (m)"
                    type="number"
                    name="digged_m"
                    :value="deliveryPhase.digged_m"
                    :required="true"
                />
            </div>
        </adaptive-form-modal>
    </span>
</template>

<script>
    export default {
        props: {
            deliveryPhase: {
                type: Object,
                required: true,
            },
            completedClasses: {
                type: String,
                default: 'btn btn-md is-ghost px-xl',
            },
            uncompletedClasses: {
                type: String,
                default: 'btn btn-md is-primary px-xl',
            },
        },
        data() {
            return {
                modalName: `address-delivery-phase-${this.deliveryPhase.address_id}-${this.deliveryPhase.type}-modal`,
                acceptedStatusTypesForHours: ['dig'],
                acceptedStatusTypesForMeters: ['dig'],
            };
        },
        computed: {
            canEnterHours() {
                return this.acceptedStatusTypesForHours.includes(this.deliveryPhase.type);
            },
            canEnterMeters() {
                return this.acceptedStatusTypesForMeters.includes(this.deliveryPhase.type);
            },
            canEditDeliveryPhase() {
                if (this.deliveryPhase.type === 'activated') {
                    return (window.App && window.App.canManageActivatedDeliveryPhase) ? window.App.canManageActivatedDeliveryPhase : false;
                }

                return true;
            },
        },
        methods: {
            async saveUncomplete() {
                const response = await axios.post(route('api.delivery-projects.addresses.delivery-phases.store', this.deliveryPhase.address_id), {
                    type: this.deliveryPhase.type,
                    completed: false,
                });
                this.$emit('delivery-phase-updated', response.data);
            },
            handleUpdateResponse(response) {
                this.$emit('delivery-phase-updated', response.data);
                this.$modal.hide(this.modalName);
            },
            showModal() {
                this.$modal.show(this.modalName);
            },
            hasSlotContent() {
                return !! this.$slots.default;
            },
        },
    };
</script>
